import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'oir-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionButtonComponent {
  @Input() title: string;
  @Input() type = '';
  @Input() set imgSrc(value: string) {
    this.customImageUrl = `url("${value}")`
  }
  @Output() readonly onClick = new EventEmitter<any>();

  public customImageUrl: string;

  onClickButton(event): void {
    this.onClick.emit(event);
  }
}
